import { useQuery } from "@tanstack/react-query"
import { paths } from "../apiTypes"

export type ProductsSummaryResponse =
  paths["/v2/vault/products/summary"]["get"]["responses"]["200"]["content"]["application/json"]

function getApiBase() {
  return process.env.NEXT_PUBLIC_EULER_API_URL ?? "http://localhost:42069"
}

export function useVaultProductsSummary(
  chainId?: number,
  {
    enabled = true,
  }: {
    enabled?: boolean
  } = {},
) {
  return useQuery<ProductsSummaryResponse>({
    queryKey: ["vaultProductsSummary", chainId],
    queryFn: async () => {
      const url = `${getApiBase()}/v2/vault/products/summary?chainId=${encodeURIComponent(
        String(chainId ?? 0),
      )}`
      const res = await fetch(url)
      if (!res.ok) {
        throw new Error(`Failed to fetch products summary: ${res.status}`)
      }
      return res.json()
    },
    enabled: enabled && !!chainId,
    refetchOnWindowFocus: false,
  })
}
